import { createGlobalStyle } from 'styled-components';
import { colors } from './colors';
import { typography } from './typography';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    overflow-y: scroll;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${typography.fonts.primary};
    background-color: ${colors.background.secondary};
    background-image: url('https://i.pinimg.com/originals/7e/3d/81/7e3d81827a53641045b853a4dec34f0e.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    color: ${colors.text.primary};
    line-height: ${typography.lineHeights.relaxed};
  }

  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(251, 249, 246, 0.8);
    z-index: -1;
  }

  #root {
    min-height: 100vh;
    isolation: isolate;
  }
  
  /* Basic accessibility and usability improvements */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }

  input, button, textarea, select {
    font: inherit;
  }
  
  button {
    cursor: pointer;
  }
`;
